export default "__VITE_ASSET__1af62912__"